/**
 * A date, a count, a rate or another figure that is not money (TMMAPP-0099, TMM-T1 / TMM-B1 1.4):
 * the body face with tabular numerals, unbroken — never mono, which is kept for identifiers,
 * references, audit timestamps, raw previews and version labels. Money is `MoneyText`.
 */
import type { ReactNode } from 'react';
import { Typography, type SxProps, type Theme, type TypographyProps } from '@mui/material';

interface TabularTextProps {
  children: ReactNode;
  variant?: 'body1' | 'body2' | 'caption';
  component?: 'span' | 'div' | 'p';
  sx?: SxProps<Theme>;
  /** For a value a keyboard user can reach (a tooltip's anchor). */
  tabIndex?: number;
  color?: TypographyProps['color'];
}

export function TabularText({
  children,
  variant = 'body1',
  component = 'span',
  sx,
  tabIndex,
  color,
}: TabularTextProps) {
  return (
    <Typography
      variant={variant}
      component={component}
      {...(tabIndex === undefined ? {} : { tabIndex })}
      {...(color === undefined ? {} : { color })}
      sx={[
        { fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' },
        ...(sx === undefined ? [] : Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Typography>
  );
}
